import React from "react";
import {Typography, Divider, Badge} from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HistoryIcon from '@mui/icons-material/History';

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function TeachingMenuSnippet({permissions, updatedShiftCount}) {
    if (!permissions.canTeach) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Teaching</Typography>
            <NavigationButton displayName="My Sessions" toLink="/mysessions">
                <TodayIcon/>
            </NavigationButton>
            <NavigationButton displayName="My History" toLink="/myhistory">
                <HistoryIcon/>
            </NavigationButton>
            <NavigationButton displayName="My Availability" toLink="/myavailability">
                <Badge badgeContent={updatedShiftCount} color="error" overlap="circular">
                    <FactCheckIcon/>
                </Badge>
            </NavigationButton>
            <Divider sx={styles.divider}/>
        </>
    );
}